<template>
  <div>
    <br />
    <form @keyup.enter="search()" @submit.prevent>
      <b-row class="row not-print mx-1">
        <b-col cols="4">
          <text-input
            v-model="searchForm.text"
            placeholder="Pesquisar"
            v-debounce:100ms="search"
          />
        </b-col>
        <b-col>
          <b-btn
            class="mr-2"
            size="sm"
            @click="showFilters = !showFilters"
            variant="primary"
          >
            <i class="fas fa-filter" /> Mais Filtros
          </b-btn>
          <b-btn size="sm" @click="search()" variant="primary"
            ><i class="fas fa-search" /> Pesquisar</b-btn
          >
        </b-col>
        <b-col cols="4" class="text-right">
          <b-dropdown
            class="mr-2"
            size="sm"
            right
            text="Colunas"
            variant="primary"
          >
            <template v-for="(field, index) in fieldsOptions">
              <b-dropdown-item :key="index" @click.capture.stop>
                <b-form-checkbox v-model="fields" :value="field">
                  {{ field.label }}
                </b-form-checkbox>
              </b-dropdown-item>
            </template>
          </b-dropdown>

          <b-btn
            size="sm"
            class="mr-2"
            @click="orientation = 'landscape'"
            :variant="orientation == 'landscape' ? 'primary' : ''"
            ><i class="mr-2 fas fa-image" />Paisagem</b-btn
          >

          <b-btn
            size="sm"
            class="mr-2"
            @click="orientation = 'portrait'"
            :variant="orientation == 'portrait' ? 'primary' : ''"
            ><i class="mr-2 fas fa-portrait" /> Retrato</b-btn
          >

          <b-btn size="sm" variant="primary" @click="print()">
            <i class="fas fa-print mr-1" /> Imprimir
          </b-btn>
        </b-col>
      </b-row>
    </form>

    <form
      class="not-print mx-4"
      v-if="showFilters"
      @keyup.enter="search()"
      @submit.prevent
    >
      <b-row>
        <b-col cols="5">
          <b-form-group label="Buscando por?">
            <b-form-radio-group
              v-model="searchForm.type"
              :options="typeOptions"
            />
          </b-form-group>
        </b-col>
        <b-col class="d-flex justify-content-end">
          <b-form-group label="Tipo:">
            <b-form-checkbox-group
              v-model="searchForm.person_type"
              :options="personTypeOptions"
            />
          </b-form-group>
        </b-col>
        <b-col class="d-flex justify-content-end">
          <b-form-group label="Status:">
            <b-form-radio-group
              v-model="searchForm.status"
              :options="statusOptions"
            />
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="3">
          <app-month-select
            v-model="searchForm.birthday_month"
            label="Selecionar mês de aniversario"
          />
        </b-col>
        <b-col cols="3">
          <search-input
            alias="Cidade"
            v-model="searchForm.city_id"
            :displayedValue="searchForm.city"
            :name="'city_id'"
            @search="searchCity($event)"
            :searchResult="searchCityResults"
            @selected="setCity($event)"
          >
            <search-input-option
              v-for="(row, index) in searchCityResults.data"
              :key="index"
              :index="index"
              @click="setCity(row)"
            >
              <div>
                {{ row.city }} - {{ row.state }}
                <br />
              </div>
            </search-input-option>
          </search-input>
        </b-col>
      </b-row>
      <b-row>
        <b-col class="mt-2" md="2">
          <b-btn @click="clear()" class="x-small" size="sm">
            <i class="fas fa-times" /> Limpar Filtro
          </b-btn>
        </b-col>
      </b-row>
    </form>

    <div class="row" style="margin: 5px">
      <div class="col">
        <b-card :title="`Relatório  de ${typeOptions[searchForm.type]}`">
          <br />
          <div class="mr-2 ml-1 row justify-content-between">
            {{ persons.length }} registros encontrados!
            <span class="font-weight-bold"
              >Consulta Realizada : {{ date | dateTimeBr }}</span
            >
          </div>
        </b-card>
      </div>
    </div>
    <div class="row" style="margin: 5px">
      <div class="col">
        <div class="card">
          <b-table sortable small :items="persons" :fields="fields">
            <template #cell(debt_limit_value)="data">{{
              data.item.debt_limit_value | decimal
            }}</template>
            <template #cell(date_birth)="data">{{
              data.item.date_birth | dateBr
            }}</template>
            <template #cell(doc)="data">
              <span v-if="data.item.person_type == 'j'">
                {{ data.item.cnpj | cnpj }}
              </span>
              <span v-if="data.item.person_type == 'f'">
                {{ data.item.cpf | cpf }}
              </span>
            </template>
            <template #cell(person_type)="data">
              {{ personTypeOptions[data.item.person_type] }}
            </template>

            <template #cell(phone2)="data">
              {{ data.item.phone2 | phone }}</template
            >
            <template #cell(phone3)="data">
              {{ data.item.phone3 | phone }}</template
            >
            <template #cell(phone4)="data">
              {{ data.item.phone4 | phone }}</template
            >
            <template #cell(phone_wa)="data">
              {{ data.item.phone_wa | phone }}</template
            >
          </b-table>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import moment from "moment";
import CategorySearch from "@/components/CategorySearch";

export default {
  props: {},
  components: {
    CategorySearch,
  },

  data() {
    return {
      persons: [],
      showFilters: false,
      searchCityResults: {},
      orientation: "portrait",
      statusOptions: [
        { value: 1, text: "Ativos" },
        { value: 0, text: "Inativos" },
      ],
      fields: [
        {
          key: "person_code",
          label: "Código",
          class: "text-center",
          sortable: true,
        },
        { key: "name", label: "Nome", class: "text-center", sortable: true },
        {
          key: "date_birth",
          label: "Data de Aniversario",
          class: "text-center",
          sortable: true,
        },
        {
          key: "phone2",
          label: "Telefone 1 ",
          class: "text-center",
          sortable: true,
        },
        {
          key: "phone_wa",
          label: "WhatsApp",
          class: "text-center",
          sortable: true,
        },
      ],

      fieldsOptions: [
        {
          key: "date_birth",
          label: "Data de Aniversario",
          class: "text-center",
          sortable: true,
        },
        {
          key: "phone2",
          label: "Telefone 1 ",
          class: "text-center",
          sortable: true,
        },
        {
          key: "phone3",
          label: "Telefone 2",
          class: "text-center",
          sortable: true,
        },
        {
          key: "phone4",
          label: "Telefone 3",
          class: "text-center",
          sortable: true,
        },
        {
          key: "phone_wa",
          label: "WhatsApp",
          class: "text-center",
          sortable: true,
        },
        {
          key: "email1",
          label: "Email 1",
          class: "text-center",
          sortable: true,
        },
        {
          key: "email2",
          label: "Email 2",
          class: "text-center",
          sortable: true,
        },
        { key: "doc", label: "CPF/CNPJ", class: "text-center", sortable: true },
        {
          key: "person_type",
          label: "Tipo",
          class: "text-center",
          sortable: true,
        },
        { key: "rg", label: "RG", class: "text-center", sortable: true },
        {
          key: "inscricao_estadual",
          label: "Inscrição Estadual",
          class: "text-center",
          sortable: true,
        },
        {
          key: "debt_limit_value",
          label: "Limite de Crédito",
          class: "text-center",
          sortable: true,
        },
        { key: "state", label: "Estado", class: "text-center", sortable: true },
        {
          key: "address",
          label: "Endereço",
          class: "text-center",
          sortable: true,
        },
        {
          key: "complement",
          label: "Complemento",
          class: "text-center",
          sortable: true,
        },
        {
          key: "district",
          label: "Bairro",
          class: "text-center",
          sortable: true,
        },
        {
          key: "number",
          label: "Número",
          class: "text-center",
          sortable: true,
        },
      ],

      searchForm: {
        type: "c",
        city_id: null,
        person_type: ["f", "j"],
        city: null,
        status: 1,
        birthday_month: moment().format("MM"),
      },

      typeOptions: {
        c: "Clientes",
        v: "Fornecedores",
        s: "Vendedores",
        sc: "Trasportadoras",
      },
      personTypeOptions: { f: "Pessoa Física", j: "Pessoa Jurídica" },
    };
  },
  mounted() {
    this.$store.commit("pageHasLoaded");
    this.search();
  },
  watch: {
    orientation: {
      deep: true,
      handler(newValue, oldValue) {
        this.setScreen();
      },
    },
  },
  computed: {
    date() {
      return moment().format();
    },
  },

  methods: {
    search() {
      this.$store
        .dispatch("person/getReport", this.searchForm)
        .then((response) => {
          this.persons = response.data.persons;
        })
        .catch((error) => {});
    },

    clear() {
      this.searchForm = {
        status: 1,
        type: "c",
        city_id: null,
        person_type: ["f", "j"],
        city: null,

        birthday_month: moment().format("MM"),

        text: null,
      };
      this.search();
    },
    print() {
      window.print();
    },

    searchCity(search) {
      axios
        .post(`${process.env.BASE_URL}api/city/selectAll?page=${search.page}`, {
          city: search.text,
        })
        .then((response) => {
          this.searchCityResults = response.data;
        })
        .catch((error) => {
          this.error = error;
        });
    },

    setCity(city) {
      this.searchForm.city_id = city.id;

      this.searchForm.city = city.city;
    },

    setScreen() {
      var styleEl = document.createElement("style");
      document.head.appendChild(styleEl);
      var styleSheet = styleEl.sheet;
      styleSheet.insertRule(`@page { size: ${this.orientation} }`, 0);
    },
  },
};
</script>

<style scoped>
body {
  margin: 0;
  padding: 0;
  background-color: #fafafa;
  color: rgb(0, 0, 0);
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto,
    "Helvetica Neue", Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji",
    "Segoe UI Symbol";
  font-size: 11pt;
}

* {
  box-sizing: border-box;
  -moz-box-sizing: border-box;
}

.page {
  width: 297mm;
  min-height: 210mm;
  padding: 0.5cm;
  margin: 0.5cm;
  border: 1px #d3d3d3 solid;
  /*    border-radius: 5px;*/
  background: white;
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.1);
}

.subpage {
  padding: 0cm;
  /*    border: 5px red solid;*/
  height: 256mm;
  outline: 2cm #ffeaea solid;
}

@page {
  size: A4;
  margin: 0.5cm;
  padding: 0.5cm;
}

@media print {
  .page {
    visibility: visible;
    margin: initial;
    border: rgba(0, 0, 0, 0.1);
    border-radius: initial;
    width: initial;
    min-height: initial;
    box-shadow: initial;
    background: initial;
    page-break-after: always;
  }

  .not-print {
    display: none;
  }
}
hr.color {
  border: 1px solid black;
}
</style>
